import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Unsubscribable } from 'rxjs';
import { Store } from '@ngrx/store';
import { SettingsSelectors } from '@rillion/store/settings';

@Pipe({
  name: 'DateMap',
})
export class MapDatePipe implements OnDestroy, PipeTransform {
  private dateFormat = 'l';
  private subscription: Unsubscribable;

  constructor(private readonly store: Store) {
    this.subscription = this.store.select(SettingsSelectors.selectLanguage).subscribe((language) => {
      this.dateFormat = language?.dateFormat ?? 'l';
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  transform(value: number) {
    return moment(value).format(this.dateFormat.toUpperCase());
  }
}
